import { createDataSelectors } from "@app/modules/app.reducers";
import { ReportTemplate } from "@ea/shared_types/types";

export const reportTemplatesDataSelectors =
  createDataSelectors<ReportTemplate>()("reportTemplates");
